/**
 * Defines the width and height of the background in pixels
 */
export const CANVAS_SIZE_PX = 64000;

/**
 * Defines the maximum zoom that can be applied. Any value larger than this
 * will be caped to this value.
 */
export const MAX_ZOOM = 3; // 300 %
/**
 * Defines the minimum zoom that can be applied. Any value smaller than this
 * will be caped to this value.
 */
export const MIN_ZOOM = 0.01; // 1 %
